import { PageLayout } from './pageLayout';
export default PageLayout;
